import { TEnhancedParamDataTableData } from "./EnhancedandGABParamDataTableMeta";

const enhancedParam: TEnhancedParamDataTableData[] = [
    {
        primaryKey: 1,
        id: "101",
        label: "Amount",
        defaultValue: "",
        minValue: "",
        maxValue: "",
        value: "000",
    },
    {
        primaryKey: 2,
        id: "103",
        label: "Date Format",
        defaultValue: "001",
        minValue: "",
        maxValue: "",
        value: "001",
    },
    {
        primaryKey: 3,
        id: "115",
        label: "Transaction status information option",
        defaultValue: "",
        minValue: "",
        maxValue: "",
        value: "001",
    },
    {
        primaryKey: 4,
        id: "104",
        label: "Roll Wid1th",
        defaultValue: "040",
        minValue: "001",
        maxValue: "040",
        value: "040",
    },
    {
        primaryKey: 5,
        id: "105",
        label: "Left Print Column",
        defaultValue: "001",
        minValue: "001",
        maxValue: "040",
        value: "001",
    },
];

const gabParamValues: Omit<TEnhancedParamDataTableData, "defaultValue" | "minValue" | "maxValue">[] = [
    {
        primaryKey: 1,
        id: "000",
        label: "Keyboard entry time-out",
        value: "019",
    },
    {
        primaryKey: 2,
        id: "002",
        label: "Close state screen time-out",
        value: "004",
    },
    {
        primaryKey: 3,
        id: "003",
        label: "Communication response time-out",
        value: "075",
    },
    {
        primaryKey: 4,
        id: "009",
        label: "Card removal time-out",
        value: "030",
    },
    {
        primaryKey: 5,
        id: "007",
        label: "Present time-out",
        value: "002",
    },
]

export default {enhancedParam, gabParamValues};